import React from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import { alert } from '@ui-kit/components/Alert/styles'
import Icon from '@ui-kit/components/Icon/index.web'

import type { WebProps } from './types'

const VARIANT_STYLE_MAP = {
  error: {
    icon: IMAGE.icons.medium.circleExclamationMarkUiRedWithLightBg_40,
  },
  warning: {
    icon: IMAGE.icons.medium.circleExclamationMarkUiOrangeWithLightBg_40,
  },
  success: {
    icon: IMAGE.icons.medium.circleCheckMarkUiGreenWithLightBg_40,
  },
} as const

const Alert = (props: WebProps): JSX.Element => {
  const variant = props.variant ?? 'error'
  const { container, title, message, textContainer } = alert({
    variant,
  })
  const imgSrc = VARIANT_STYLE_MAP[variant].icon
  return (
    <div
      className={container()}
      data-testid={props.id}
      id={props.id}
      onClick={props.onClick}
      onKeyUp={props.onKeyUp}
      role="button"
    >
      <Icon imgSrc={typeof imgSrc === 'string' ? imgSrc : imgSrc.default.src} />
      <div className={textContainer()}>
        {props.title && <p className={title()}> {props.title}</p>}
        <p className={message()}>{props.message}</p>
      </div>
      {props.icon}
    </div>
  )
}

export default Alert
